import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('invitationsTable');

    return {
        ACTIONS_LABEL: t('actionsLabel'),
        DELETE: t('delete'),
        DELETE_CONFIRM_CANCEL: t('deleteConfirmCancel'),
        DELETE_CONFIRM_LABEL: t('deleteConfirmLabel'),
        DELETE_CONFIRM_MESSAGE: t('deleteConfirmMessage'),
        DELETE_CONFIRM_TITLE: t('deleteConfirmTitle'),
        EMAIL: t('email'),
        EMPTY_DESCRIPTION: t('emptyDescription'),
        EMPTY_HEADING: t('emptyHeading'),
        EXPIRES: t('expires'),
        LOAD_MORE: t('loadMore'),
        RESEND: t('resend'),
        ROLE: t('role'),
        SENT: t('sent'),
        STATUS: t('status'),
        TABLE_LABEL: t('tableLabel')
    };
};

export default useTranslation;
